import { HttpErrorResponse } from "@angular/common/http";
import { ViewEncapsulation, OnInit, ViewChild, ElementRef, Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TraceClassDecorator } from "@sentry/angular";
import { MessageService, LazyLoadEvent, SelectItem } from "primeng";
import { PatientFilterQuery, transaction_status } from "../../../../../models/AccountFilter";
import { PatientAccounts, refundBody } from "../../../../../models/Accounts";
import { payment_method } from "../../../../../models/basket";
import { invoice, PatientAccountInvoice } from "../../../../../models/invoice";
import { PromiseResult, ErrorModel, ServerError } from "../../../../../models/PromiseResult";
import { AccountsService } from "../../../../../services/accounts.service";
import { PatientRefundService } from "../../../../../services/accounts/patient.refund.service";
import { CountriesService } from "../../../../../services/countries.service";
import { getEnumValues } from "../../../../../utilities/utilities.service";
import { DoctorBreadcrumbService } from "../../../shared/breadcrumb.service";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { URLS } from "src/app/constant/constant";

class PaymentDetails {
    payment_method: payment_method;
    status: string;
    method?: string;
    braintree_transaction_status?: string;
    braintree_processor_response_text?: string;
    dialog = false;
}
@TraceClassDecorator()
@Component({
    selector: 'app-patientaccounts',
    templateUrl: './patientaccounts.component.html',
    styleUrls: ['./patientaccounts.component.css'
        , '../../../../../../assets/css/custom-egd.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class PatientaccountsComponent implements OnInit {
    @ViewChild('htmlData') htmlData: ElementRef;

    query: PatientFilterQuery;
    disabledDates: boolean = true;
    display: boolean = false;
    success: boolean = null;
    consultations: SelectItem[];
    ErrorMessage: string = null;
    display1: boolean = false;
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    loading: boolean;
    is_uk_country: boolean = false;
    maxDate: Date = new Date();
    transaction_id: any;
    transaction_no: string = null;
    invoice_id: string = null;
    patient_guid: string = null;

    showInvoice: string = 'showInvoice';
    printContent: string = 'print-content';
    total_records: number = 0;
    private async ResetResponseModel(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    showDialog() {
        this.display = true;
    }
    countries: SelectItem[] = [];

    displayModal: boolean = false;

    PatientAccount: PatientAccounts[] = [];
    invoice: invoice;
    PatientinvoiceTable: PatientAccountInvoice[] = [];
    payment = new PaymentDetails();

    displayedColumns: string[] = [
        'sr_no',
        'name',
        'medical_record_number',
        'created_at',
        'country_name',
        'consultation_name',
        'transaction_no',
        'status',
        'rendered_amount',
        'invoice'
    ];

    displayedColumns2: string[] = [
        'sr_no',
        'created_at',
        'transaction_no',
        'Description',
        'Amount'
    ];

    refresh = false;
    provider_id: string = "";
    refund_dialog: boolean = false;
    refundBody: refundBody = {
        refund_reason: "",
        transaction_id: null,
        is_auto: null,
        refund_percent: 0
    }
    is_refunded: boolean = false;
    invalid_date_message: boolean = false;
    inv_transaction_id: string = null;
    fetched: any;
    slug: string = "";
    status_list: SelectItem[] = [{ label: 'All', value: null }]
    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly accountsService: AccountsService,
        private readonly countryService: CountriesService,
        private readonly patientRefund: PatientRefundService,
        private readonly messageService: MessageService,
        private readonly titleService: Title,
        private readonly providerStateService: ProviderStateService
    ) {
        this.maxDate = new Date();
    }

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Patients Accounts");
        this.slug = this.providerStateService.getProviderSlug();
        if (URLS.IS_UK) {
            this.is_uk_country = true
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Accounts' },
            { label: 'Patients' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.posting = false;
        this.loading = false;
        await this.InitFilter(false);
        this.consultations = [
            {
                label: 'All',
                value: -1
            },
            {
                label: 'Membership',
                value: 0
            },
            // {
            //     label: 'Expert Second Medical Opinion',
            //     value: 1
            // },
            {
                label: 'Primary Medical Consultation',
                value: 2
            },
            {
                label: 'Follow Up Consultation',
                value: 3
            },
            {
                label: 'Multi Specialty Consultation',
                value: 4
            },
            // {
            //     label: 'Diet and Nutrition',
            //     value: 5
            // }
        ];

        if (!this.is_uk_country) {
            this.consultations.push({
                label: 'Diet and Nutrition',
                value: 5
            });
        } else if (!this.is_uk_country) {
            this.consultations.push({
                label: 'Expert Second Medical Opinion',
                value: 1
            });
        }
        else if (this.is_uk_country) {
            this.consultations.push({
                label: 'Specialist Consultation',
                value: 1
            });
        }
        this.status_list = getEnumValues(transaction_status).map(s => {
            return {
                label: s,
                value: s
            }
        })
        await this.GetCountries();
        await this.GetTransactions(null);
    }

    async GetCountries() {
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((result) => {
                this.countries = [];
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                for (const country of result)
                    temp.push({
                        label: country.country_name,
                        value: country.id
                    });
                this.countries = temp;
            });
    }

    async InitFilter(call_api: boolean) {
        this.disabledDates = true;
        this.invalid_date_message = false;
        this.query = {
            consultation_type_id: -1,
            to_date: null,
            from_date: null,
            country_id: 0,
            page_no: 1,
            records_per_page: 10,
            status: transaction_status.complete,
            first: 0
        }
        if (call_api)
            await this.GetTransactions(null);
    }

    async GetTransactions(event: LazyLoadEvent) {
        await this.ResetResponseModel();
        if (!this.disabledDates && (this.query.from_date == null || this.query.to_date == null)) {
            this.invalid_date_message = true;
            return;
        }
        if (this.invalid_date_message && ((this.query.from_date != null && this.query.to_date != null) || this.disabledDates))
            this.invalid_date_message = false;
        this.posting = true;
        this.loading = true;
        if (event != null) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        else {
            this.query.page_no = 1;
            this.query.first = 0;
        }
        this.PatientAccount = [];
        this.ErrorMessage = null;
        await this.accountsService
            .GetPatientTransactions(this.query)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    this.total_records = result.data.count;
                    const rec = result.data.rows;
                    const temp: PatientAccounts[] = [];
                    for (let i = 0; i < rec.length; i++) {
                        let transaction_obj: PatientAccounts = {
                            sr_no:
                                i +
                                1 +
                                (this.query.page_no - 1) *
                                this.query.records_per_page,
                            created_at: rec[i].transaction.created_at,
                            name:
                                rec[i].transaction.p_accounts.first_name +
                                ' ' +
                                (rec[i].transaction.p_accounts.middle_name == null ? '' : rec[i].transaction.p_accounts.middle_name) +
                                ' ' +
                                rec[i].transaction.p_accounts.last_name,
                            medical_record_number:
                                rec[i].transaction.p_accounts.medical_record_number,
                            country_name:
                                rec[i].transaction.p_priority.country
                                    .country_name,
                            consultation_name:
                                rec[i].transaction.p_priority.consultation_name,
                            transaction_no: rec[i].transaction.transaction_no,
                            status: rec[i].transaction.status,
                            rendered_amount: rec[i].rendered_amount,
                            rendered_actual_amount: rec[i].rendered_actual_amount,
                            invoice: rec[i].transaction.p_invoice,
                            invoice_id:
                                rec[i].transaction.p_invoice == null
                                    ? 'N/A'
                                    : rec[i].transaction.p_invoice.invoice_id,
                            patient_guid:
                                rec[i].transaction.p_accounts.patient_guid,
                            id: rec[i].transaction.id,
                            payment_id: null,
                            payment_gateway: rec[i].transaction.payment_gateway_type,
                            is_package: rec[i].transaction.user_package_id == null ? false : true,
                            isConsultationNotClosed: rec[i].transaction.p_consultation?.consultation_status != "CLOSED" || false,
                            isDietConsultation: rec[i].transaction.p_priority == null ? false : (rec[i].transaction.p_priority.consultation_type_id == 5 || false),
                            con_status: rec[i].transaction.p_consultation?.consultation_status || 'N/A'
                        };
                        if (rec[i].transaction.paypal != null)
                            transaction_obj.payment_id = rec[i].transaction.paypal.paypal_transaction_id;
                        else if (rec[i].transaction.razor_pay != null)
                            transaction_obj.payment_id = rec[i].transaction.razor_pay.payment_id;
                        else if (rec[i].transaction.patient_stripe_transaction != null)
                            transaction_obj.payment_id = rec[i].transaction.patient_stripe_transaction.stripe_invoice_id;
                        temp.push(transaction_obj);
                    }
                    this.PatientAccount = temp;
                } else if (!this.response.success) {
                    this.ErrorMessage = result.error.message;
                }
                this.posting = false;
                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
                this.loading = false;
            });
    }

    async ClickInvoice(transaction_id: string) {
        await this.ResetResponseModel();
        this.posting = true;
        this.success = null;
        this.displayModal = true;
        await this.accountsService
            .GetInvoice(transaction_id)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    this.fetched = result.data;
                    this.ErrorMessage = null;
                } else if (!this.response.success) {
                    this.ErrorMessage = result.error.message;
                    this.PatientinvoiceTable = [];
                }
                this.success = result.success;
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
    }

    async printi(transaction_id: string) {
        this.inv_transaction_id = transaction_id;
        await this.ClickInvoice(transaction_id);
        this.displayModal = true;
    }

    print() {
        window.print();
    }

    async refundDialogAction(transaction_id: string, open: boolean, status?: string): Promise<void> {
        this.refund_dialog = open;
        this.refundBody.transaction_id = open ? transaction_id : null;
        this.is_refunded = status == transaction_status.refunded;
    }

    async refund(body: refundBody): Promise<void> {
        await this.ResetResponseModel();
        this.posting = true;
        await this.patientRefund.refund(body)
            .toPromise()
            .then((result: PromiseResult) => {
                this.response = result;
                this.posting = false;
                if (result.success) {
                    this.refundDialogAction(null, false);
                    this.messageService.add(
                        {
                            severity: 'success',
                            summary: 'Request succeeded',
                            detail: 'Refund request has been successfully raised.'
                        }
                    );
                }
                else {
                    this.messageService.add(
                        {
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Something went wrong.'
                        }
                    );
                }
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            })
    }

    async findPaymentInfo(payment_id: string, payment_gateway: payment_method): Promise<void> {
        this.payment = new PaymentDetails();
        await this.accountsService.findPaymentDetails(payment_id, payment_gateway)
            .toPromise()
            .then(result => {
                if (result.success) {
                    this.payment = new PaymentDetails();
                    this.payment.payment_method = payment_gateway;
                    this.payment.status = result.data.status;
                    if (payment_gateway == payment_method.paypal) {
                        this.payment.braintree_processor_response_text = result.data.braintree_processor_response_text;
                        this.payment.braintree_transaction_status = result.data.braintree_transaction_status;
                    }
                    else if (payment_gateway == payment_method.razorpay) {
                        this.payment.method = result.data.method;
                    } else if (payment_gateway == payment_method.stripe) {
                        this.payment.method = "Stripe";
                    }
                    this.payment.dialog = true;
                }
            })
    }

}
